import { useRef as a } from "react";
import { useControlledState as u } from "../../../hooks/useControlledState.js";
const c = ({
  defaultShow: o,
  show: r
}) => {
  const e = a(!1), {
    isControlled: s,
    setValue: t,
    value: n
  } = u({
    component: "IressPopover",
    defaultValue: o,
    propName: "show",
    value: r
  });
  return {
    hasInnerRole: () => e.current,
    isControlled: s,
    setShow: t,
    setHasInnerRole: (l) => {
      e.current = l;
    },
    show: !!n
  };
};
export {
  c as usePopoverState
};
